import * as Yup from 'yup';
import { FC, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Typography,
  Autocomplete
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../../../utils/request';
import { LoadingButton } from '@mui/lab';
import SnackbarAlert from '../../../common/SnackbarAlert';
import React from 'react';
import AutocompleteLoader from '../../../common/AutocompleteLoader';
type CreateEditProps = {
  closeCreateEditForm: any;
  sectionEditDatas: any;
  editStatus: boolean;
  productId: any;
  setNewValue?: Function;
};
const CreateEdit: FC<CreateEditProps> = ({
  closeCreateEditForm,
  sectionEditDatas,
  editStatus,
  productId,
  setNewValue
}) => {
  const SectionSchema = Yup.object().shape({
    sectionName: Yup.string()
      .required('Section Name is required')
      .min(3, 'Section Name must be at least 3 characters')
      .test(
        'notOnlyWhiteSpace',
        'Section Name cannot include leading and trailing spaces',
        (value) => {
          return !/\s{2,}/.test(value);
        }
      ),
      // .matches(
      //   /^[^-!@#$%^&*()_+={};:'",.<>/?\\|[\]`~].*$/,
      //   'Section Name cannot start with a special character'
      // )
      // .matches(
      //   /^[a-zA-Z0-9\s]+(\s?[-_.]\s?[a-zA-Z0-9]+)*$/,
      //   'Section Name only accepts special charaters `.`,`-` followed by alphanumeric characters and cannot include leading and trailing spaces'
      // )
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\<>]*$/,
      //   'Section Name only accepts special characters like &,[,],-,/,(,),<,>'
      // )
      // .matches(
      //   /[a-zA-Z]/,
      //   'Section Name must include at least one letter of the alphabet'
      // ),
    // .test(
    //   'notOnlyWhiteSpace',
    //   'Section Name cannot include leading and trailing spaces',
    //   (value) => {
    //     return !/\s{2,}/.test(value);
    //   }
    // ),
    sectionCode: Yup.string()
      .required('Section Code is required')
      .test(
        'notOnlyWhiteSpace',
        'Section Code cannot include leading and trailing spaces',
        (value) => {
          return !/\s{2,}/.test(value);
        }
      )
      .min(2, 'Section Code must be at least 2 characters'),
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\]*$/,
      //   'Section Code only accepts special characters like &,[,],-,/,(,)'
      // ),
    // .matches(
    //   alphanumericSpecialcharacterCodeRegex,
    //   'Section Code only accept special character `-` followed by alphanumeric values and cannot include leading and trailing spaces '
    // )
    // .matches(
    //   /^[^-!@#$%^&*()_+={};:'",.<>/?\\|[\]`~].*$/,
    //   'Section Code cannot start with a special character'
    // )
    sectionRate: Yup.number()
      .notRequired()
      .typeError('Section Rate is not valid')
      .positive('Must be a positive number.')
      .min(1, 'Section Rate must be greater than or equal to 1')
      .transform((value, originalValue) => {
        return /\s/.test(originalValue) ? NaN : value;
      })
      .test('len', 'Length is too long', (val) => {
        if (val === undefined || val === null) return true;
        const valStr = val.toString();
        const maxLength = valStr.includes('.') ? 10 : 8;
        return valStr.length <= maxLength;
      })
      .test(
        'max-two-decimals',
        'Section Rate must have at most two decimal places',
        (value) => {
          if (value === undefined || value === null) return true;
          const decimalPlaces = value.toString().split('.')[1];
          return !decimalPlaces || decimalPlaces.length <= 2;
        }
      )
      .nullable()
  });
  const [isLoading, setLoading] = useState<boolean>(true);
  const [loader, setLoader] = useState<boolean>(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState<{
    status: boolean;
    type: string;
    message: any;
  }>({
    status: false,
    type: 'success',
    message: null
  });
  const [productData, setProductData] = useState<any>([]);
  const [productSearchValue, setProductSearchValue] = useState<string>('');
  const [productValue, setProductValue] = useState<any>(null);
  const formik = useFormik({
    initialValues: {
      id: '',
      sectionName: '',
      sectionCode: '',
      sectionRate: '',
      status: true,
      productId: productId
    },
    validationSchema: SectionSchema,
    onSubmit: (values) => {
      setLoader(true);
      const method = editStatus ? 'PUT' : 'POST';
      request({
        url: 'section',
        method: method,
        data: values
      })
        .then((section) => {
          if (section.status) {
            closeCreateEditForm(true);
            setLoader(false);
            if (setNewValue) {
              setNewValue(values?.sectionName);
            }
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: section['message']
            });
          }
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  });
  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productSearchValue]);
  const fetchProducts = async () => {
    request({
      url: 'policyProduct/getPolicyProductList',
      method: 'post',
      data: {
        search: productSearchValue,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: 0,
        limit: 100,
        status: true
      }
    }).then(
      (response) => {
        setProductData(response['policyProductData']);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (editStatus) {
      fetchPolicyProductNameById();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchPolicyProductNameById = async () => {
    request({
      url: 'policyProduct/getPolicyProductNameById',
      method: 'post',
      data: {
        id: sectionEditDatas?.productId
      }
    }).then(
      (response: any) => {
        formik.setValues((prev) => ({
          ...prev,
          productId: response?.id
        }));
        setProductSearchValue(response?.name);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };
  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  if (editStatus) {
    formik.values.id = sectionEditDatas.id;
    formik.initialValues.sectionName = sectionEditDatas.sectionName;
    formik.initialValues.sectionCode = sectionEditDatas.sectionCode;
    formik.initialValues.sectionRate = sectionEditDatas.sectionRate;
  }
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              {editStatus ? (
                <CardHeader title="Update Section" />
              ) : (
                <CardHeader title="Create Section" />
              )}
              <Divider />

              <CardContent>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Section Name{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="sectionName"
                        value={capitalizeFirst(formik.values.sectionName)}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('sectionName', trimmedValue);
                          formik.handleBlur(e);
                        }}
                        error={
                          formik.touched.sectionName &&
                          Boolean(formik.errors.sectionName)
                        }
                        helperText={
                          formik.touched.sectionName &&
                          formik.errors.sectionName
                        }
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Section Code{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="sectionCode"
                        value={formik.values.sectionCode}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('sectionCode', trimmedValue);
                          formik.handleBlur(e);
                        }}
                        error={
                          formik.touched.sectionCode &&
                          Boolean(formik.errors.sectionCode)
                        }
                        helperText={
                          formik.touched.sectionCode &&
                          formik.errors.sectionCode
                        }
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label={<React.Fragment>Section Rate </React.Fragment>}
                        sx={{ width: '100%' }}
                        size="small"
                        name="sectionRate"
                        type="number"
                        onKeyDown={(e) => {
                          if (['e', 'E', '-', '+'].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.sectionRate}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          const formattedValue = e.target.value?.includes('.')
                            ? e.target.value.replace(
                                /(\.\d*?[1-9])0+$|\.0*$/,
                                '$1'
                              )
                            : e.target.value;
                          formik.setFieldValue(
                            'sectionRate',
                            formattedValue,
                            true
                          );
                          formik.handleBlur(e);
                        }}
                        error={
                          formik.touched.sectionRate &&
                          Boolean(formik.errors.sectionRate)
                        }
                        helperText={
                          formik.touched.sectionRate &&
                          formik.errors.sectionRate
                        }
                      />
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      mt={2}
                    >
                      {loader ? (
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          loading={loader}
                          variant="contained"
                          type="submit"
                        >
                          Save
                        </LoadingButton>
                      ) : (
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          type="submit"
                          variant="contained"
                        >
                          Save
                        </Button>
                      )}
                      &nbsp;
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        color="error"
                        onClick={closeCreateEditForm}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CreateEdit;
